import React from "react";
import { taxBudgetMessage } from "../constant";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
const TaxBudgetInfo = (props) => {
    const device = DeviceContext();
    if (props.liesInTaxBudgetDateRange)
        return (React.createElement("div", { className: !(device === null || device === void 0 ? void 0 : device.isDesktop) ? "py-3" : "ps-2 my-2" },
            React.createElement("div", { className: "DMSansMedium_12_500 txt-light-purple" }, "Disclaimer"),
            React.createElement("div", { className: `DMsanR_10_400 txt_greyOne py-2 ${!(device === null || device === void 0 ? void 0 : device.isDesktop) ? "linehei12" : ""}` }, taxBudgetMessage)));
    return React.createElement(React.Fragment, null);
};
export default TaxBudgetInfo;
